function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H36V36H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1d1d",
  d: "M.845-7.355a2.952 2.952 0 0 1 2.147-.907A2.892 2.892 0 0 1 5.1-7.39a2.882 2.882 0 0 1 .88 2.128 2.882 2.882 0 0 1-.88 2.128 2.892 2.892 0 0 1-2.111.872A2.892 2.892 0 0 1 .88-3.134 2.882 2.882 0 0 1 0-5.262a2.827 2.827 0 0 1 .845-2.093zm18.018 0a2.952 2.952 0 0 1 2.147-.907 2.892 2.892 0 0 1 2.111.872A2.882 2.882 0 0 1 24-5.262a2.882 2.882 0 0 1-.88 2.128 2.892 2.892 0 0 1-2.111.872 2.892 2.892 0 0 1-2.109-.872 2.882 2.882 0 0 1-.88-2.128 2.827 2.827 0 0 1 .842-2.093zm-9.009 0A2.952 2.952 0 0 1 12-8.262a2.892 2.892 0 0 1 2.111.872 2.882 2.882 0 0 1 .88 2.128 2.882 2.882 0 0 1-.88 2.128A2.892 2.892 0 0 1 12-2.262a2.892 2.892 0 0 1-2.111-.872 2.882 2.882 0 0 1-.88-2.128 2.827 2.827 0 0 1 .844-2.093z",
  transform: "translate(6 23.262)"
});

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/iconMenu.2a20681f.svg";
export { ForwardRef as ReactComponent };